import { render, staticRenderFns } from "./AddAssignment.vue?vue&type=template&id=677b7ed4&scoped=true&"
import script from "./AddAssignment.vue?vue&type=script&lang=js&"
export * from "./AddAssignment.vue?vue&type=script&lang=js&"
import style0 from "./AddAssignment.vue?vue&type=style&index=0&id=677b7ed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677b7ed4",
  null
  
)

export default component.exports